import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import {
  selectCustomer,
  selectHideInvoiced,
  selectShowJobDate, selectTruck,
  setFilterFormExpanded
} from '@main/delivery-slips/store/delivery-slip-filter.actions';

export const featureKey = 'delivery-slip-filter';

export interface State {
  filterFormExpanded: boolean;
  selectHideInvoiced: boolean;
  selectShowJobDate: boolean;
  selectedCustomerId: number;
  selectedTruckId: number;
}

export const initialState: State = {
  filterFormExpanded: false,
  selectHideInvoiced: false,
  selectShowJobDate: false,
  selectedCustomerId: null,
  selectedTruckId: null,
};

const deliverySlipFilterReducer = createReducer(
  initialState,
  on(selectHideInvoiced, (state, { hideInvoiced }): State => ({ ...state, selectHideInvoiced: hideInvoiced})),
  on(selectShowJobDate, (state, { showJobDate }): State => ({ ...state, selectShowJobDate: showJobDate})),
  on(selectTruck, (state, { truckId }): State => ({ ...state, selectedTruckId: truckId})),
  on(selectCustomer, (state, { customerId }): State => ({...state, selectedCustomerId: customerId})),
  on(setFilterFormExpanded, (state, { expanded }): State => ({ ...state, filterFormExpanded: expanded })),
);

export function reducer(state: State | undefined, action: Action) {
  return deliverySlipFilterReducer(state, action);
}

export const selectDeliverySlipFilterState = createFeatureSelector< State>(featureKey);
export const selectFilterFormExpanded = createSelector(selectDeliverySlipFilterState, (state: State) => state.filterFormExpanded);
